(function () {
  var TAG = 'New Arrivals';
  function badge(card) {
    if (card.dataset.ocdBadgeDone === card.id) return;
    card.dataset.ocdBadgeDone = card.id;
    var old = card.querySelector('.ocd-new-badge');
    if (old) old.remove();
    var raw = card.getAttribute('data-product');
    if (!raw) return;
    var tags;
    try { tags = JSON.parse(raw).tags || []; } catch (e) { return; }
    if (tags.indexOf(TAG) === -1) return;
    var slot = card.querySelector('.boost-sd__product-image-column--in-top.boost-sd__product-image-column--left') || card.querySelector('.boost-sd__product-image-wrapper');
    if (!slot) return;
    var el = document.createElement('span');
    el.className = 'ocd-new-badge';
    el.textContent = 'New';
    slot.appendChild(el);
  }
  function scan(root) {
    (root || document).querySelectorAll('.boost-sd__product-item').forEach(badge);
  }
  scan();
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches('.boost-sd__product-item')) badge(n);
        else scan(n);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();